import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";
import {ReportComponentModel} from "../../../api/entity/reportComponent.model";
import {ReportComponentConverter} from "../../../api/entity/converter/reportComponent.converter";

@Injectable()
export class ReportComponentDataService extends AbstractDataServiceV2<ReportComponentModel, ReportComponentConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: ReportComponentConverter) {
        super('ReportComponent', http, httpUrlGenerator, logger, config, converter);
    }
}
